// src/contexts/NotificationContext.jsx

import { createContext, useContext } from 'react';

export const NotificationContext = createContext(null);

export const useNotificationContext = () => {
	const context = useContext(NotificationContext);

	if (!context) {
		throw new Error(
			'useNotificationContext must be used within NotificationContext.Provider'
		);
	}

	return context;
};
